$giper_baza_land_page $mol_page
	land $giper_baza_land
	pawn $giper_baza_dict
		link => pawn_link
	head /
		<= Pawn_link $giper_baza_link_chip
			link <= pawn_link
		<= Meta_link $giper_baza_link_chip
			link <= meta_link $giper_baza_link
			sub / \✨
		<= Tools
	body /
		<= Flex $giper_baza_flex_form
			pawn <= pawn
		<= Raw $mol_labeler
			Content <= Raw_content $mol_list rows /
				<= Raw_data $giper_baza_pawn_dump
					title \Data
					pawn <= pawn
				<= Raw_tine $giper_baza_pawn_dump
					title \Tine
					pawn <= tine $giper_baza_pawn
		- <= Text $mol_textarea
			value? <=> text? \
			selection? <=> selection? /
				0
				0
	foot /
		<= Fork $mol_button_minor
			hint \Fork this land
			sub / <= Fork_icon $mol_icon_source_fork
			click? <=> fork? null
		<= Dumping $mol_view sub /
			<= Size $mol_view sub / <= size \0 KB
			<= Dump $mol_button_download
				hint \Download dump
				blob <= dump $mol_blob
				file_name <= dump_name \AAAAAAAA_AAAAAAAA.baza
